import IosStylePicker from './IosStylePicker';
export default IosStylePicker;
